export const tr = {
    'preview-cancel': 'İptal',
    'preview-select': 'Seç'
};
